// extracted by mini-css-extract-plugin
export default {"innerWrapper":"_A-z","tooltipWrapper":"aB-z","icon":"bB-z","tooltip":"cB-z","content":"dB-z"};